
// Dependencies
import Vue from 'vue'
import VueRouter from 'vue-router'
import vueResource from 'vue-resource'
import VeeValidate from 'vee-validate'
import VueProgressBar from 'vue-progressbar'
import Meta from 'vue-meta'
import Clipboard from 'v-clipboard'
// import {Spinner} from 'spin.js';

// Components
import CNpay from './components/CNpay/index.vue'
// import CNpay2 from './components/CNpay2/index.vue'
import Login from './components/Login/index.vue'
import Wallet from './components/Wallet/index.vue'
Vue.config.productionTip = false


Vue.use(Clipboard)
Vue.use(VueRouter)
Vue.use(Meta)
Vue.use(vueResource)
Vue.use(VeeValidate)
Vue.use(VueProgressBar, {
  color: 'rgb(143, 255, 199)',
  failedColor: 'red',
  height: '5px'
})
// Vue.use(Spinner)

const router = new VueRouter({
  mode: 'history',
  base: __dirname,
  routes: [
   
    {path: '/', name: 'CNpay', component: CNpay},
    // {path: '/cnpay2', name: 'CNpay2', component: CNpay2},
    {path: '/login', name: 'Login', component: Login},
    // {path: '/wallet', name: 'Wallet', component: Wallet},
    {path: '/rewards', name: 'Wallet', component: Wallet},
    {path: '*', redirect: '/'} // 404
  ]
})

/* eslint-disable no-new */
new Vue({
  router,
  template: `
    <div id="app">
      <vue-progress-bar></vue-progress-bar>
      <router-view></router-view>
    </div>
    `
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js